(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('axios')) :
    typeof define === 'function' && define.amd ? define(['exports', 'axios'], factory) :
    (global = global || self, factory(global.petfinder = {}, global.axios));
}(this, function (exports, axios) { 'use strict';

    axios = axios && axios.hasOwnProperty('default') ? axios['default'] : axios;

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var ApiClient = /** @class */ (function () {
        function ApiClient(client) {
            this.client = client;
            this.http = client.http;
        }
        ApiClient.prototype.ensureAuthenticated = function () {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!("Authorization" in this.http.defaults.headers.common)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.client.authenticate()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        return ApiClient;
    }());

    var Animal = /** @class */ (function (_super) {
        __extends(Animal, _super);
        function Animal() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Animal.prototype.search = function (params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/animals", {
                                    params: params,
                                })];
                    }
                });
            });
        };
        Animal.prototype.show = function (id) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/animals/" + id)];
                    }
                });
            });
        };
        return Animal;
    }(ApiClient));

    var AnimalData = /** @class */ (function (_super) {
        __extends(AnimalData, _super);
        function AnimalData() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AnimalData.prototype.types = function () {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/types")];
                    }
                });
            });
        };
        AnimalData.prototype.type = function (type) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/types/" + type)];
                    }
                });
            });
        };
        AnimalData.prototype.breeds = function (type) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/types/" + type + "/breeds")];
                    }
                });
            });
        };
        return AnimalData;
    }(ApiClient));

    var Organization = /** @class */ (function (_super) {
        __extends(Organization, _super);
        function Organization() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Organization.prototype.search = function (params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/organizations", {
                                    params: params,
                                })];
                    }
                });
            });
        };
        Organization.prototype.show = function (id) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.ensureAuthenticated()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.http.get("/organizations/" + id)];
                    }
                });
            });
        };
        return Organization;
    }(ApiClient));

    var ProblemDetailsError = /** @class */ (function (_super) {
        __extends(ProblemDetailsError, _super);
        function ProblemDetailsError(request, response) {
            var _this = _super.call(this, response.data.title) || this;
            _this.request = request;
            _this.response = response;
            _this.type = response.data.type;
            _this.status = response.data.status;
            _this.details = response.data.detail;
            _this.invalidParams = response.data["invalid-params"];
            Object.setPrototypeOf(_this, ProblemDetailsError.prototype);
            return _this;
        }
        return ProblemDetailsError;
    }(Error));

    var Client = /** @class */ (function () {
        function Client(config) {
            var _this = this;
            this.config = config;
            this.http = axios.create({
                baseURL: config.baseUrl || "https://api.petfinder.com/v2",
                headers: { "x-api-sdk": "petfinder-js-sdk/v1.0 (https://github.com/petfinder-com/petfinder-js-sdk)" },
            });
            this.http.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                if (error.response && _this.isProblemDetailsResponse(error.response)) {
                    return Promise.reject(new ProblemDetailsError(error.request, error.response));
                }
                return Promise.reject(error);
            });
        }
        Object.defineProperty(Client.prototype, "animalData", {
            get: function () {
                return new AnimalData(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Client.prototype, "animal", {
            get: function () {
                return new Animal(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Client.prototype, "organization", {
            get: function () {
                return new Organization(this);
            },
            enumerable: true,
            configurable: true
        });
        Client.prototype.authenticate = function (token) {
            return __awaiter(this, void 0, Promise, function () {
                var response, accessToken;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            accessToken = token || this.config.token;
                            if (!!accessToken) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.http.post("/oauth2/token", {
                                    client_id: this.config.apiKey,
                                    client_secret: this.config.secret,
                                    grant_type: "client_credentials",
                                })];
                        case 1:
                            response = _a.sent();
                            accessToken = response.data.access_token;
                            _a.label = 2;
                        case 2:
                            this.config.token = accessToken;
                            this.http.defaults.headers.common.Authorization = "Bearer " + accessToken;
                            return [2 /*return*/, response];
                    }
                });
            });
        };
        Client.prototype.isProblemDetailsResponse = function (response) {
            var headers = response.headers || {};
            var contentType = headers["content-type"] || "";
            return contentType.includes("application/problem+json");
        };
        return Client;
    }());

    exports.Client = Client;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
